import { useState, useEffect } from 'react';
import { UserDetail } from 'common/components/userDetail';
import { UserDetails, TransferUniversalDashboardData } from 'TAP/redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { getAuthToken } from 'common/authentication/authToken';
import { getUserAgentBrowser, getUserAgentOS, isLocalStorageKeyExistDefined } from 'TAP/utils/commonMethods';
import { NUMBER_ARRAY } from 'common/global/constants';

export const RoleMatrix = () => {
  const [initializer, setInitializer] = useState(false);
  const uerDetailFrmMSAL = UserDetail().userEmailId;
  const dispatch = useDispatch();
  const getLoggedInUserDetails = useSelector((state) => state.tapUserDetailsRd);
  const universalDashboardData = useSelector((state) => state?.universalDashboardReducer);
  const currTime = new Date().toISOString('en-US', { timeZone: 'UTC' });

  useEffect(() => {
    if (!initializer) {
      let delegateObj = undefined;
      if(isLocalStorageKeyExistDefined('delegateProfileSwitched') && localStorage.getItem('delegateProfileSwitched') !== '[object Object]'){
        delegateObj = JSON.parse(localStorage.getItem('delegateProfileSwitched'));
      }
      // Invoke the /user/profile API only if access token is available
      let token = getAuthToken();
      if (!getLoggedInUserDetails?.userDetails && token?.idToken && uerDetailFrmMSAL) {
        dispatch(
          UserDetails({
            email: delegateObj?.isDelegateSwitch ? delegateObj.email : uerDetailFrmMSAL,
          }),
        );
      }
    }
    setInitializer(true);
  }, [initializer]);

  useEffect(() => {
    if (getLoggedInUserDetails && Object.keys(getLoggedInUserDetails)?.length > NUMBER_ARRAY.zero) {
      const userData = JSON.parse(localStorage.getItem('userDetails'));
      if (
        !userData?.idSession &&
        !userData?.loggedInTime &&
        getLoggedInUserDetails.userDetails?.data[NUMBER_ARRAY.zero]?.user_email
      ) {
        dispatch(
          TransferUniversalDashboardData({
            apiType: 'user_session_loggedin',
            apiSubType: '',
            userEmailId: getLoggedInUserDetails.userDetails?.data[NUMBER_ARRAY.zero]?.user_email,
            appName: process.env.REACT_APP_NAME,
            targetUrl: 'session',
            startDateTime: currTime ?? null,
            endDateTime: null,
            ipAddress: null,
            idSession: null,
            browser: getUserAgentBrowser(),
            os: getUserAgentOS(),
          }),
        );
      }
      localStorage.setItem(
        'userDetails',
        JSON.stringify({
          ...getLoggedInUserDetails.userDetails?.data[NUMBER_ARRAY.zero],
          idSession: userData?.idSession ?? null,
          loggedInTime: userData?.loggedInTime ?? null,
        }),
      );
    }
  }, [getLoggedInUserDetails]);

  useEffect(() => {
    if (
      universalDashboardData?.apiResponse?.data?.data?.idSession &&
      universalDashboardData?.apiResponse?.data?.data?.sessionStart
    ) {
      localStorage.setItem(
        'userDetails',
        JSON.stringify({
          ...JSON.parse(localStorage.getItem('userDetails')),
          idSession: universalDashboardData?.apiResponse?.data?.data?.idSession,
          loggedInTime: universalDashboardData?.apiResponse?.data?.data?.sessionStart,
        }),
      );
    }
  }, [universalDashboardData?.apiResponse]);

  return getLoggedInUserDetails?.userDetails &&
    Object.keys(getLoggedInUserDetails?.userDetails)?.length > NUMBER_ARRAY.zero
    ? {
        user_id: getLoggedInUserDetails.userDetails?.data[0].user_id,
        full_name: getLoggedInUserDetails.userDetails?.data[0].full_name,
        user_email: getLoggedInUserDetails.userDetails?.data[0].user_email,
        user_hire_date: getLoggedInUserDetails.userDetails?.data[0].user_hire_date,
        manager_id: getLoggedInUserDetails.userDetails?.data[0].manager_id,
        indirect_manager_id: getLoggedInUserDetails.userDetails?.data[0].indirect_manager_id,
        is_admin: getLoggedInUserDetails.userDetails?.data[0].is_admin,
        is_active: getLoggedInUserDetails.userDetails?.data[0].is_active,
        is_deleted: getLoggedInUserDetails.userDetails?.data[0].is_deleted,
        created_date: getLoggedInUserDetails.userDetails?.data[0].created_date,
        updated_date: getLoggedInUserDetails.userDetails?.data[0].updated_date,
        last_refresh_date: getLoggedInUserDetails.userDetails?.data[0].last_refresh_date,
        is_manager: getLoggedInUserDetails.userDetails?.data[0].is_manager,
        user_role: getLoggedInUserDetails.userDetails?.data[0].user_role,
      }
    : JSON.stringify({});
};
